import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import WarningObject from "../objects/WarningObject";
import type { MapLayerProps, WarningMapObject } from "../types";

type WarningsLayerProps = MapLayerProps<WarningMapObject>;

const WarningsLayer = ({
    id,
    items,
    selectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: WarningsLayerProps) => {
    const { items: layerItems } = useMapLayer({ items, selectedIds });
    const baseObjects = useMemo(
        () =>
            layerItems.map((item) => (
                <WarningObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    selected={selectedIds?.has(item.id) ?? false}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, layerItems, onItemClick, onItemHover, onItemLeave, selectedIds],
    );

    return <pixiContainer label="warnings-layer">{baseObjects}</pixiContainer>;
};

export default WarningsLayer;
